export type Lang = 'en' | 'ar';

const translations: Record<string, Record<Lang, string>> = {
  // Landing
  'landing.badge': { en: 'Launch your store today', ar: 'أطلق متجرك اليوم' },
  'landing.title1': { en: 'Create Your Online Store', ar: 'أنشئ متجرك الإلكتروني' },
  'landing.title2': { en: 'In Minutes', ar: 'في دقائق' },
  'landing.subtitle': { en: 'Everything you need to sell online. Beautiful storefront, order management, delivery tracking, and analytics — all under your brand at', ar: 'كل ما تحتاجه للبيع عبر الإنترنت. واجهة متجر جميلة، إدارة الطلبات، تتبع التوصيل، والتحليلات — كل ذلك تحت علامتك التجارية في' },
  'landing.cta': { en: 'Create Your Store', ar: 'أنشئ متجرك' },
  'landing.features': { en: 'See Features', ar: 'شاهد المزايا' },
  'landing.stores': { en: 'Active Stores', ar: 'متجر نشط' },
  'landing.orders': { en: 'Orders Processed', ar: 'طلب تمت معالجته' },
  'landing.uptime': { en: 'Uptime', ar: 'وقت التشغيل' },

  // Features
  'features.title': { en: 'Everything You Need to Sell Online', ar: 'كل ما تحتاجه للبيع عبر الإنترنت' },
  'features.subtitle': { en: 'Powerful tools to create, manage, and grow your online store', ar: 'أدوات قوية لإنشاء وإدارة وتنمية متجرك الإلكتروني' },
  'feat.store': { en: 'Online Store', ar: 'متجر إلكتروني' },
  'feat.store.desc': { en: 'Beautiful, customizable storefront with your own subdomain', ar: 'واجهة متجر جميلة وقابلة للتخصيص مع نطاق فرعي خاص بك' },
  'feat.layouts': { en: 'Multiple Layouts', ar: 'تصاميم متعددة' },
  'feat.layouts.desc': { en: 'Choose from modern, classic, minimal, or elegant designs', ar: 'اختر من التصاميم العصرية أو الكلاسيكية أو البسيطة أو الأنيقة' },
  'feat.mobile': { en: 'Mobile Ready', ar: 'متوافق مع الجوال' },
  'feat.mobile.desc': { en: 'Fully responsive design that works on all devices', ar: 'تصميم متجاوب يعمل على جميع الأجهزة' },
  'feat.delivery': { en: 'Delivery & Pickup', ar: 'توصيل واستلام' },
  'feat.delivery.desc': { en: 'Built-in delivery management and pickup options', ar: 'إدارة توصيل مدمجة وخيارات استلام' },
  'feat.analytics': { en: 'Analytics', ar: 'التحليلات' },
  'feat.analytics.desc': { en: 'Track orders, revenue, and performance in real-time', ar: 'تتبع الطلبات والإيرادات والأداء في الوقت الفعلي' },
  'feat.domain': { en: 'Custom Domain', ar: 'نطاق مخصص' },
  'feat.domain.desc': { en: 'Use your own domain or our free subdomain', ar: 'استخدم نطاقك الخاص أو نطاقنا الفرعي المجاني' },

  // How it works
  'how.title': { en: 'Get Started in 3 Easy Steps', ar: 'ابدأ في 3 خطوات سهلة' },
  'how.step1': { en: 'Sign Up', ar: 'سجل حساب' },
  'how.step1.desc': { en: 'Create your account and choose your store name. Your store URL will be yourname.cartz.cc', ar: 'أنشئ حسابك واختر اسم متجرك. رابط متجرك سيكون yourname.cartz.cc' },
  'how.step2': { en: 'Customize', ar: 'خصص' },
  'how.step2.desc': { en: 'Upload your logo, pick colors, choose a layout, and add your products', ar: 'ارفع شعارك، اختر الألوان، اختر التصميم، وأضف منتجاتك' },
  'how.step3': { en: 'Start Selling', ar: 'ابدأ البيع' },
  'how.step3.desc': { en: 'Share your store link and start receiving orders immediately', ar: 'شارك رابط متجرك وابدأ في استقبال الطلبات فوراً' },

  // Layouts
  'layouts.title': { en: 'Choose Your Store Layout', ar: 'اختر تصميم متجرك' },
  'layouts.subtitle': { en: 'Multiple professionally designed layouts to match your brand', ar: 'تصاميم احترافية متعددة تناسب علامتك التجارية' },

  // Pricing
  'pricing.title': { en: 'Simple, Transparent Pricing', ar: 'أسعار بسيطة وشفافة' },
  'pricing.subtitle': { en: 'Try any plan free for 15 days — no credit card required', ar: 'جرّب أي خطة مجاناً لمدة 15 يوم — بدون بطاقة ائتمانية' },

  // CTA
  'cta.title': { en: 'Ready to Launch Your Store?', ar: 'مستعد لإطلاق متجرك؟' },
  'cta.subtitle': { en: 'Join hundreds of merchants already selling with Cartz', ar: 'انضم لمئات التجار الذين يبيعون عبر كارتز' },
  'cta.btn': { en: 'Create Your Free Store', ar: 'أنشئ متجرك المجاني' },

  // Nav
  'nav.features': { en: 'Features', ar: 'المزايا' },
  'nav.pricing': { en: 'Pricing', ar: 'الأسعار' },
  'nav.how': { en: 'How it Works', ar: 'كيف يعمل' },
  'nav.login': { en: 'Login', ar: 'تسجيل الدخول' },
  'nav.create': { en: 'Create Store', ar: 'أنشئ متجر' },

  // Auth
  'auth.login.title': { en: 'Welcome Back', ar: 'مرحباً بعودتك' },
  'auth.login.subtitle': { en: 'Sign in to your account', ar: 'تسجيل الدخول إلى حسابك' },
  'auth.login.btn': { en: 'Sign In', ar: 'تسجيل الدخول' },
  'auth.login.loading': { en: 'Signing in...', ar: 'جاري تسجيل الدخول...' },
  'auth.login.forgot': { en: 'Forgot password?', ar: 'نسيت كلمة المرور؟' },
  'auth.login.switch': { en: "Don't have an account?", ar: 'ليس لديك حساب؟' },
  'auth.login.switch.link': { en: 'Create your store', ar: 'أنشئ متجرك' },
  'reset.title': { en: 'Reset Password', ar: 'إعادة تعيين كلمة المرور' },
  'reset.subtitle': { en: 'Enter your email to receive a reset code', ar: 'أدخل بريدك الإلكتروني لتلقي رمز إعادة التعيين' },
  'reset.sendCode': { en: 'Send Reset Code', ar: 'إرسال رمز إعادة التعيين' },
  'reset.sending': { en: 'Sending...', ar: 'جاري الإرسال...' },
  'reset.codeLabel': { en: 'Reset Code', ar: 'رمز إعادة التعيين' },
  'reset.codePlaceholder': { en: 'Enter 6-digit code', ar: 'أدخل الرمز المكون من 6 أرقام' },
  'reset.codeSubtitle': { en: 'Enter the code sent to your email', ar: 'أدخل الرمز المرسل إلى بريدك الإلكتروني' },
  'reset.newPassword': { en: 'New Password', ar: 'كلمة المرور الجديدة' },
  'reset.confirmPassword': { en: 'Confirm New Password', ar: 'تأكيد كلمة المرور الجديدة' },
  'reset.submit': { en: 'Reset Password', ar: 'إعادة تعيين كلمة المرور' },
  'reset.resetting': { en: 'Resetting...', ar: 'جاري إعادة التعيين...' },
  'reset.backToLogin': { en: 'Back to login', ar: 'العودة لتسجيل الدخول' },
  'reset.resendCode': { en: 'Resend code', ar: 'إعادة إرسال الرمز' },
  'auth.register.title': { en: 'Create Your Store', ar: 'أنشئ متجرك' },
  'auth.register.subtitle': { en: 'Fill in your details to get started', ar: 'أدخل بياناتك للبدء' },
  'auth.register.btn': { en: 'Create My Store', ar: 'أنشئ متجري' },
  'auth.register.loading': { en: 'Creating Store...', ar: 'جاري إنشاء المتجر...' },
  'auth.register.switch': { en: 'Already have an account?', ar: 'لديك حساب بالفعل؟' },
  'auth.register.switch.link': { en: 'Sign in', ar: 'تسجيل الدخول' },
  'auth.left.title.login': { en: 'Manage Your Store', ar: 'أدر متجرك' },
  'auth.left.desc.login': { en: 'Access your dashboard to manage products, orders, and customize your store.', ar: 'ادخل لوحة التحكم لإدارة المنتجات والطلبات وتخصيص متجرك.' },
  'auth.left.title.register': { en: 'Start Selling Today', ar: 'ابدأ البيع اليوم' },
  'auth.left.desc.register': { en: 'Create your online store in minutes. Choose your name, customize your design, and start receiving orders.', ar: 'أنشئ متجرك الإلكتروني في دقائق. اختر اسمك، خصص تصميمك، وابدأ في استقبال الطلبات.' },

  // Form labels
  'form.firstName': { en: 'First Name', ar: 'الاسم الأول' },
  'form.lastName': { en: 'Last Name', ar: 'اسم العائلة' },
  'form.email': { en: 'Email', ar: 'البريد الإلكتروني' },
  'form.password': { en: 'Password', ar: 'كلمة المرور' },
  'form.confirmPassword': { en: 'Confirm Password', ar: 'تأكيد كلمة المرور' },
  'form.storeName': { en: 'Store Name', ar: 'اسم المتجر' },
  'form.companyName': { en: 'Company Name', ar: 'اسم الشركة' },
  'form.optional': { en: 'Optional', ar: 'اختياري' },

  // Footer
  'footer.product': { en: 'Product', ar: 'المنتج' },
  'footer.company': { en: 'Company', ar: 'الشركة' },
  'footer.legal': { en: 'Legal', ar: 'قانوني' },
  'footer.about': { en: 'About', ar: 'عن كارتز' },
  'footer.blog': { en: 'Blog', ar: 'المدونة' },
  'footer.contact': { en: 'Contact', ar: 'تواصل معنا' },
  'footer.privacy': { en: 'Privacy Policy', ar: 'سياسة الخصوصية' },
  'footer.terms': { en: 'Terms of Service', ar: 'شروط الخدمة' },
  'footer.tagline': { en: 'The easiest way to create and manage your online store.', ar: 'أسهل طريقة لإنشاء وإدارة متجرك الإلكتروني.' },
  'footer.rights': { en: '2026 Cartz. All rights reserved.', ar: '2026 كارتز. جميع الحقوق محفوظة.' },
};

export function t(key: string, lang: Lang): string {
  return translations[key]?.[lang] || key;
}
